import React from 'react'
import PropTypes from 'prop-types'
import {
  ELECTRONIC_GIFT_CARD_MAX,
  ELECTRONIC_GIFT_CARD_MIN,
} from 'shared/constants'
import { giftCardPDPPath } from 'lib/urls'
import PriceRangeOffer from 'components/offer/price-range-offer'
import DeferredPaymentMessage from 'components/deferred-payment-message'

const GiftCardOffer = ({
  disableLink,
  regItemId,
  showDeferredPaymentMessage,
}) => (
  <>
    <PriceRangeOffer
      disableLink={disableLink}
      storeDisplayName="Babylist"
      storeIconName="babylist"
      url={
        regItemId
          ? `${giftCardPDPPath}?reg_item_id=${regItemId}`
          : giftCardPDPPath
      }
      rangeStart={ELECTRONIC_GIFT_CARD_MIN}
      rangeEnd={ELECTRONIC_GIFT_CARD_MAX}
    />
    {showDeferredPaymentMessage && (
      <DeferredPaymentMessage className="mas" isElectronicGiftCard />
    )}
  </>
)

GiftCardOffer.propTypes = {
  disableLink: PropTypes.bool,
  regItemId: PropTypes.number,
  showDeferredPaymentMessage: PropTypes.bool.isRequired,
}

GiftCardOffer.defaultProps = {
  disableLink: false,
  regItemId: false,
}

export default GiftCardOffer
